import React, { useState, useEffect, Fragment } from "react";
import MasonryGrid from "./MasonryGrid";
import { MediaItem } from "api/mediaApi";

interface Props {
    feeds: MediaItem[];
    filters: any;
}

function Tabs({ feeds, filters }: Props) {
    const [activeTab, setActiveTab] = useState(0);
    const tabData = [
        {
            title: 'Foryou',
            id: 'tab1',
            component: <MasonryGrid feeds={feeds} filters={filters} />,
        },
        {
            title: 'Explore',
            id: 'tab2',
            component: <MasonryGrid feeds={feeds} filters={filters} />,
        },
    ];
    return (
        <Fragment>
            <div className="container xl:mb-24 mb-14 lg:mt-[unset] mt-4">
                {/* Tab Buttons */}
                <div className="mb-4 dark:border-gray-700">
                    <ul
                        className="flex -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400 overflow-x-auto no-scrollbar"
                        role="tablist"
                    >
                        {tabData.map((tab, index) => (
                            <li key={tab.id} className="me-2" role="presentation">
                                <button
                                    className={`inline-block 
                                        rounded-full lg:rounded-none
                                        px-4 py-[10px] lg:p-4 
                                        ${activeTab === index
                                            ? 'text-white bg-primaryColor lg:text-[#E10001] lg:bg-transparent lg:border-b-2 lg:border-[#E10001]'
                                            : 'border-transparent lg:text-[#515D6F] text-black hover:border-gray-300'}
                                    `}
                                    type="button"
                                    role="tab"
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.title}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Tab Content */}
                <div id="default-styled-tab-content">
                    {tabData.map((tab, index) => (
                        <div
                            key={tab.id}
                            className={`pt-2 ${activeTab === index ? 'block' : 'hidden'
                                }`}
                            role="tabpanel"
                        >
                            {tab.component}
                        </div>
                    ))}
                </div>
            </div>
        </Fragment>
    )
}
export default Tabs;